import { makeRequest } from 'utils/requestLogger';

export default (id) =>
  makeRequest('get', `/api/live_discussions/${id}/generate-exportable-data`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/generateExportableData.js